import type {SuggestRepository} from '../../repo/suggest/types'
import {toAddressesSuggest} from './mappers/to-address-suggest'
import {toSuggestBody} from './mappers/to-suggest-body'
import type {SuggestService} from './type'

export * from './type'

export function createSuggestService(phoenixRepository: SuggestRepository): SuggestService {
  const {fetchSuggest} = phoenixRepository

  return {
    fetchAddressSuggest(params) {
      const body = toSuggestBody(params)
      return fetchSuggest(body).then(toAddressesSuggest(body))
    },
  }
}
